import { Component, OnInit } from '@angular/core';
import { NgSelectConfig } from '@ng-select/ng-select';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
import { AuthFacade } from './@modules/auth/facade/auth.facade';
import { DataSourceUploadProgressService } from './@modules/data-source/services/data-source-upload-progress.service';
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "../environments/environment";
import { NbDialogService } from "@nebular/theme";
import { SutveyDialogComponent } from "./@modules/main/modules/management/components/setting/dialogs/sutvey-dialog/sutvey-dialog.component";
import { LocalStorageManagerService } from "./@modules/shared/services/local-storage-manager.service";
import { NetworkMonitorService } from './@modules/shared/services/network-monitor.service';
import { filter } from 'rxjs';
import { SocketUtils } from "./@modules/shared/helpers";
import { SocketActionsEnum } from "./@modules/shared/models";
import { SignalRService } from "./@modules/shared/services/socket/signal-r.service";
import { ToastrWrapperService } from './@modules/shared/services/toastr-wrapper.service';
import { DataSourceFacade } from './@modules/data-source/facade/data-source.facade';
import buildInfo from "../build";

declare var window: any;

/**
 * Root component of entire application
 */
@Component({
  selector: 'morva',
  template: `
    <router-outlet></router-outlet>
    <morva-data-source-upload-progress-modal cdkDrag style="position: absolute; bottom:0; left:0; z-index:1000;">
    </morva-data-source-upload-progress-modal>`,
})
export class AppComponent implements OnInit {

  isSharedDashboard = false;
  constructor(
    private analytics: AnalyticsService, private seoService: SeoService, private config: NgSelectConfig,
    private progressService: DataSourceUploadProgressService,
    private dialogService: NbDialogService,
    private authFacade: AuthFacade, private router: Router,
    private networkMonitor: NetworkMonitorService,
    private signalRService: SignalRService,
    private toaster: ToastrWrapperService,
    private dataSourceFacade: DataSourceFacade
  ) {
    this.config.notFoundText = 'موردی یافت نشد';
    this.isSharedDashboard = (window?.location.href.indexOf('share-dashboard/view/') !== -1);
    if(!this.isSharedDashboard){
      this.authFacade.loadUserAuthentication$()
        .subscribe(userAuthentication => this.authFacade.updateUserAuthentication(userAuthentication));
    }
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.networkMonitor.startMonitoring();
    });
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    if(!this.isSharedDashboard){
      this.authFacade.autoLogin();
      this.authFacade.loadRegisterByUser();
      this.authFacade.autoLogoutAlltabs();
      this.authFacade.autoLogoutAlltabs();
      const userDetails = JSON.parse(this.authFacade.getLocalStorageData('userData'));
      if(userDetails && userDetails.accessToken){
        this.progressService.reload();
        this.authFacade.getSurveyStatus();
      }
    }
    const userDetails = JSON.parse(this.authFacade.getLocalStorageData('userData'));
    if(userDetails && userDetails.accessToken){
      this.signalRService.startConnection();
    }

    SocketUtils.listenToSocketEventByActionName(SocketActionsEnum.FORCE_LOG_OUT).subscribe(res=>{
      if(!res) return
      this.authFacade.resetStates();
      this.signalRService.stopConnection();
      this.toaster.showError('نشست ورود شما نامعتبر است. کاربر دیگری با استفاده از حساب کاربری شما وارد سیستم شده است.');
      this.router.navigate(['/auth/login']);
    });

    this.initListeners();
    console.log('%c TART BI ', 'color:#009fe3; font-family:\'sans-serif\';' +
      ' display: block;font-weight:bold; font-size:48px; background:#fff;');
      console.log(
        `%cBuild Info:\n\n` +
        `%c ❯ Environment: %c${environment.production ? "production 🏭" : "development 🚧"}\n` +
        `%c ❯ Build Timestamp: %c${buildInfo.timestamp}\n` +
        `%c ❯ Commit Full Hash: %c${buildInfo.git.fullHash}\n` +
        `%c ❯ Commit Hash: %c${buildInfo.git.hash}`,
        "font-size: 14px; color: #7c7c7b;",
        "font-size: 12px; color: #7c7c7b;",
        environment.production
          ? "font-size: 12px; color: #e26565;"
          : "font-size: 12px; color: #95c230;",
        "font-size: 12px; color: #7c7c7b;",
        "font-size: 12px; color: #bdc6cf;",
        "font-size: 12px; color: #7c7c7b;",
        "font-size: 12px; color: #bdc6cf;",
        "font-size: 12px; color: #7c7c7b;",
        "font-size: 12px; color: #bdc6cf;"
      );
    
    SocketUtils.listenToSocketEventByActionName(SocketActionsEnum.UPDATE_DATASOURCE).subscribe(res=>{
      if(!res) return
      this.dataSourceFacade.updateDataSourceUploadProgress(res);
    });
  }

  private initListeners(){
    this.authFacade.getSurveyDetails$().subscribe((res)=>{
      if(res){
        const {isSurveyDone} = res;
        if(!isSurveyDone){
          const isSurveyStatusDisabled = LocalStorageManagerService.getItem(LocalStorageManagerService.surveyStatusKey);
          if(!isSurveyStatusDisabled || isSurveyStatusDisabled !== 'true'){
            this.dialogService.open(SutveyDialogComponent, {
              closeOnBackdropClick: false,
              // context: { userId: this.userMinInfo.id },
            });
          }
        }
      }
    })
  }

}
